import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {Col, Row, Container} from "reactstrap";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class PollingUnitFormData {
    @observable code = '';
    @observable name = '';
    @observable station_number = '';
    @observable state_id: number | null = null;
    @observable is_active = true;
    @observable local_government_area_id: number | null = null;
    @observable ward_id: number | null = null;
    @observable register_voters: number | null = null;
    @observable pvc_register_voters: number | null = null;
}

export class PollingUnitForm extends CrudForm {
    modelName = 'PollingUnit';

    renderFields() {
        return (
            <>
                <Field
                    label="Code"
                    name="code"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Polling Unit"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                {/*<Field
                    label="Station Number"
                    name="station_number"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />*/}

                <Field
                    label="State"
                    name="state_id"
                    component={Select}
                    required={true}
                    loadOptions={api.state.getListAction}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('local_government_area_id', null);
                        this.formStore.setValue('ward_id', null);
                    }}
                />

                <Field
                    label="Reg. Voters"
                    name="register_voters"
                    type="number"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />
				
				 <Field
                    label="PVC Collected"
                    name="pvc_register_voters"
                    type="number"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />



                <Field
                    key={this.formStore.getValue('state_id')}
                    label="Local Government Area"
                    name="local_government_area_id"
                    component={Select}
                    required={true}
                    valueObject={true}
                    loadOptions={() => {
                        return api.localGovernmentArea.getListAction({
                            filters: {
                                state_id: this.formStore.getValue('state_id')
                            }
                        });
                    }}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('ward_id', null);
                    }}
                />

                <Field
                    key={"ward_id_" + this.formStore.getValue('state_id') + this.formStore.getValue('local_government_area_id')}
                    label="Ward"
                    name="ward_id"
                    component={Select}
                    required={true}
                    valueObject={true}
                    loadOptions={() => {
                        return api.ward.getListAction({
                            filters: {
                                state_id: this.formStore.getValue('state_id'),
                                local_government_area_id: this.formStore.getValue('local_government_area_id'),
                            }
                        });
                    }}
                    store={this.formStore}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class PollingUnitFilterForm {
    @observable state_id = null;
    @observable local_government_area_id = null;
    @observable ward_id = null;
    @observable senatorial_district_id = null;
    @observable federal_constituency_id = null;
    @observable state_constituency_id = null;
    @observable is_filter_on_region = 1;
}

export class PollingUnitList extends CrudList {
    modelName = 'PollingUnit';

    defaultSortColumn = 'state.name';
    defaultSortDirection = 'asc';


    senatorialDistrictDropDown() {
        return <Col md={2}>
            <Field
                key={'senatorial_district_id_' +
                    this.filterFormStore.getValue('state_id') 
                }
                name="senatorial_district_id"
                placeholder="Select Senatorial Districts"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.senatorialDistrict.getListAction({
                        filters: {
                            state_id: this.filterFormStore.getValue('state_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={(item: any) => {
                    this.filterFormStore.setValue('ward_id', null);
                    this.filterFormStore.setValue('local_government_area_id', null);
                }}
            />
        </Col>;
    }

    federalConstituencyDropDown() {
        return <Col md={2}>
            <Field
                key={'federal_constituency_id_' +
                this.filterFormStore.getValue('state_id')
                }
                name="federal_constituency_id"
                placeholder="Select Federal Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.federalConstituency.getListAction({
                        filters: {
                            state_id: this.filterFormStore.getValue('state_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={(item: any) => {
                    this.filterFormStore.setValue('ward_id', null);
                    this.filterFormStore.setValue('local_government_area_id', null);
                }}
            />
        </Col>;
    }

    stateConstituencyDropDown() {
        return <Col md={2}>
            <Field
                key={'state_constituency_id_' +
                    this.filterFormStore.getValue('state_id')
                }
                name="state_constituency_id"
                placeholder="Select State Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.stateConstituency.getListAction({
                        filters: {
                            state_id: this.filterFormStore.getValue('state_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={(item: any) => {
                    this.filterFormStore.setValue('ward_id', null);
                }}
            />
        </Col>;
    }

    colums() {
        return [
            {
                name: "station_number",
                label: "Station Number",
                sort: true,
            },
            {
                name: "state.code",
                label: "State Code",
                sort: true,
            },
            {
                name: "state.name",
                label: "State",
                sort: true,
            },
            {
                name: "local_government_area.name",
                label: "LGA",
                sort: true,
            },
            {
                name: "ward.name",
                label: "Ward",
                sort: true,
            },
            {
                name: "name",
                label: "Polling Unit",
                sort: true,
            },
            {
                name: "code",
                label: "Polling Unit Code",
                sort: true,
            },
            {
                name: "register_voters",
                label: "INEC REG. Voters",
                sort: true,
            },
			{
                name: "pvc_register_voters",
                label: "PVC Collected",
                sort: true,
            },
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        return (
            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
            <Row className="form-row">
                <Col md={3}>
                    <Field
                        name="state_id"
                        placeholder="Select State"
                        component={Select}
                        loadOptions={api.state.getListAction}
                        store={this.filterFormStore}
                        onChange={() => {
                            this.filterFormStore.setValue('local_government_area_id', null);
                            this.filterFormStore.setValue('ward_id', null);
                        }}
                    />
                </Col>

                {this.senatorialDistrictDropDown()}
                {this.federalConstituencyDropDown()}

                <Col md={3}>
                    <Field
                        key={'filter-lga-' +
                        this.filterFormStore.getValue('state_id') +
                        this.filterFormStore.getValue('senatorial_district_id') +
                        this.filterFormStore.getValue('federal_constituency_id')
                        }
                        name="local_government_area_id"
                        placeholder="Select LGA"
                        component={Select}
                        loadOptions={() => {
                            return api.localGovernmentArea.getListAction({
                                filters: {
                                    state_id: this.filterFormStore.getValue('state_id'),
                                    senatorial_district_id: this.filterFormStore.getValue('federal_constituency_id') ? null :
                                        this.filterFormStore.getValue('senatorial_district_id'),
                                    federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
                                }
                            });
                        }}
                        store={this.filterFormStore}
                        onChange={() => {
                            this.filterFormStore.setValue('ward_id', null);
                        }}
                    />
                </Col>

                {this.stateConstituencyDropDown()}

                <Col md={3}>
                    <Field
                        key={"ward_id_" +
                            this.filterFormStore.getValue('local_government_area_id') +
                            this.filterFormStore.getValue('state_id') +
                            this.filterFormStore.getValue('state_constituency_id')
                        }
                        name="ward_id"
                        placeholder="Select Ward"
                        component={Select}
                        loadOptions={() => {
                            return api.ward.getListAction({
                                filters: {
                                    state_id: this.filterFormStore.getValue('state_id'),
                                    state_constituency_id: this.filterFormStore.getValue('state_constituency_id'),
                                    local_government_area_id: this.filterFormStore.getValue('state_constituency_id') ? null :
                                        this.filterFormStore.getValue('local_government_area_id'),
                                }
                            });
                        }}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class PollingUnitPage extends CrudPage {
    modelName = 'PollingUnit';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/PollingUnitPage.tsx